import {
    SHUEISHA_ONLINE_ACCEPT_CALLBACK_URLS,
    SHUEISHA_ONLINE_CONFIRM_COMPONENT,
    SHUEISHA_ONLINE_DEFAULT_CALLBACK_URL,
    SHUEISHA_ONLINE_EMAIL_DOMAINS,
    SHUEISHA_ONLINE_LINKAGE_ID,
    SHUEISHA_ONLINE_LINKAGE_NAME,
    SHUEISHA_ONLINE_PATH,
    SHUEISHA_ONLINE_PROFILE_COMPONENT,
    SHUEISHA_ONLINE_SERVICE_TERM_URL,
    SHUEISHA_ONLINE_SITE_UNIQ_API_PATH
} from "@/commons/linkage/sites/shueisha_online";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import { LinkageRouteNames } from "@/commons/linkage/linkageCommon";
import LinkageMailMagazine from "@/views/Linkage/User/LinkageMailMagazine.vue";
import LinkageMailMagazineConfirm from "@/views/Linkage/User/LinkageMailMagazineConfirm.vue";
import LinkageMailMagazineComplete from "@/views/Linkage/User/LinkageMailMagazineComplete.vue";
import LinkageMailMagazineRescueProfile from "@/views/Linkage/User/LinkageMailMagazineRescueProfile.vue";
import LinkageMailMagazineRescueProfileConfirm from "@/views/Linkage/User/LinkageMailMagazineRescueProfileConfirm.vue";

// SHUEISHA_ONLINE画面用ルート定義
const routes = createLinkageRoute(
    SHUEISHA_ONLINE_LINKAGE_ID,
    SHUEISHA_ONLINE_LINKAGE_NAME,
    SHUEISHA_ONLINE_PATH,
    SHUEISHA_ONLINE_SITE_UNIQ_API_PATH,
    SHUEISHA_ONLINE_DEFAULT_CALLBACK_URL,
    SHUEISHA_ONLINE_ACCEPT_CALLBACK_URLS,
    SHUEISHA_ONLINE_SERVICE_TERM_URL,
    SHUEISHA_ONLINE_EMAIL_DOMAINS,
    SHUEISHA_ONLINE_PROFILE_COMPONENT,
    SHUEISHA_ONLINE_CONFIRM_COMPONENT,
    {
        emailParamNotRequired: true,
    },
);

// 集英社オンライン用メールマガジン画面定義
const RouteNames = new LinkageRouteNames(SHUEISHA_ONLINE_LINKAGE_ID, SHUEISHA_ONLINE_LINKAGE_NAME);
const mailMagazineViews = [
    {
        path: "mail_magazine",
        name: RouteNames.MAIL_MAGAZINE,
        component: LinkageMailMagazine,
        meta: { title: "メールマガジン購読" },
    },
    {
        path: "mail_magazine_confirm",
        name: RouteNames.MAIL_MAGAZINE_CONFIRM,
        component: LinkageMailMagazineConfirm,
        meta: { title: "メールマガジン購読(変更確認)" },
    },
    {
        path: "mail_magazine_complete",
        name: RouteNames.MAIL_MAGAZINE_COMPLETE,
        component: LinkageMailMagazineComplete,
        meta: { title: "メールマガジン購読(変更完了)" },
    },
    {
        path: "mail_magazine/rescue_profile",
        name: RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE,
        component: LinkageMailMagazineRescueProfile,
        meta: { title: "会員情報変更" },
        props: true,
        children: [
            {
                path: "",
                name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child`,
                component: SHUEISHA_ONLINE_PROFILE_COMPONENT,
                props: { nextRoute: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM}Child` }
            }
        ]
    },
    {
        path: "mail_magazine/rescue_profile_confirm",
        name: RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM,
        component: LinkageMailMagazineRescueProfileConfirm,
        meta: { title: "会員情報変更(確認)" },

        beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
            if (!from.name) {
                next({ name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child` });
            } else {
                next();
            }
        },
        children: [
            {
                path: "",
                name: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE_CONFIRM}Child`,
                component: SHUEISHA_ONLINE_CONFIRM_COMPONENT,
                props: { prevRoute: `${RouteNames.MAIL_MAGAZINE_RESCUE_PROFILE}Child`, nextRoute: RouteNames.PROFILE_COMPLETE }
            }
        ]
    },
];

// RouteNames.USER_PARENTのルート定義を検索
const findUserParent = (routes: RouteRecordRaw[]): RouteRecordRaw | undefined => {
    let found = routes.find(r => r.name === RouteNames.USER_PARENT);
    if (!found) {
        found = findUserParent(routes.filter(r => r.children).flatMap(r => r.children) as RouteRecordRaw[]);
    }
    return found;
};
// RouteNames.USER_PARENTにメルマガ関連画面定義をマージ
const userParentRoute = findUserParent(routes);
userParentRoute?.children?.push(...mailMagazineViews);

// SHUEISHA_ONLINE画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// 集英社オンライン画面用ルータ
export const ShueishaOnlineRouter = router;
